var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220 240",
    width: 220,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 650,
    height: 1600,
    id: "img1",
    href: "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDY1MCAxNjAwIiB3aWR0aD0iNjUwIiBoZWlnaHQ9IjE2MDAiPjxzdHlsZT4uYXtmaWxsOiNmYmMzYTR9PC9zdHlsZT48cGF0aCBjbGFzcz0iYSIgZD0ibTM5Mi44IDMwNS43cS02OC42IDI5LjMtMTM3LjEgMCAzNC4zLTU4LjYgMC0xMTcuMiA2OC41LTI5LjMgMTM3LjEgMC0zNC4zIDU4LjYgMCAxMTcuMnoiLz48L3N2Zz4="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    transform: "matrix(.786,0,0,.772,-146,-59)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeck);
export default __webpack_public_path__ + "static/media/neck.dca2076b19e70dc5c0635acd7f901356.svg";
export { ForwardRef as ReactComponent };